/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GenericResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { TerminiAccettazioneForm } from '../model/models';
import { TerminiStatoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AccettaTerminiCassiereRequestParams {
    terminiAccettazioneForm: TerminiAccettazioneForm;
}

export interface AccettaTerminiEsercenteRequestParams {
    terminiAccettazioneForm: TerminiAccettazioneForm;
}


export interface EsercenteConsensiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Registra l\&#39;accettazione dei termini e privacy del cassiere.
     * Audience: CASSIERE autenticato. Versione non corrente: 422. Ri-accettazione della stessa versione consentita. Con la raccolta sospesa e\&#39; un no-op.
     * @endpoint post /api/v1/esercente/consensi/termini-cassiere
* @param requestParameters
     */
    accettaTerminiCassiere(requestParameters: AccettaTerminiCassiereRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Registra l\&#39;accettazione dei termini e privacy dell\&#39;esercente.
     * Audience: ESERCENTE autenticato. Versione non corrente: 422. Ri-accettazione della stessa versione consentita. Con la raccolta sospesa e\&#39; un no-op.
     * @endpoint post /api/v1/esercente/consensi/termini
* @param requestParameters
     */
    accettaTerminiEsercente(requestParameters: AccettaTerminiEsercenteRequestParams, extraHttpRequestParams?: any): Observable<GenericResponseDTO>;

    /**
     * Stato di accettazione dei termini e privacy del cassiere autenticato.
     * Audience: CASSIERE autenticato. Stessa risposta del cittadino, sul documento del cassiere.
     * @endpoint get /api/v1/esercente/consensi/termini-cassiere
*/
    getStatoTerminiCassiere(extraHttpRequestParams?: any): Observable<TerminiStatoDTO>;

    /**
     * Stato di accettazione dei termini e privacy dell\&#39;esercente autenticato.
     * Audience: ESERCENTE autenticato. Stessa risposta del cittadino: versione corrente, versione accettata con data e da_accettare (pilota la schermata bloccante di primo accesso).
     * @endpoint get /api/v1/esercente/consensi/termini
*/
    getStatoTerminiEsercente(extraHttpRequestParams?: any): Observable<TerminiStatoDTO>;

}
